import CostCenterItemTableCell from './CostCenterItemTableCell'
export default CostCenterItemTableCell
